export default __webpack_public_path__ + "img/0a448f0c945937ed56798db44e2025f7.png";